module.exports = {"top3":["Home health patients with a hospital admission","Home health patients without improved mobility","Adults with any mental illness reporting unmet need"],"bottom3":["Uninsured adults","Medicare spending per beneficiary","Children without a medical home"],"most_improved":["Nursing home residents with an antipsychotic medication","Uninsured children","Home health patients without improved mobility"],"most_declined":["Drug poisoning deaths","Preventable hospitalizations ages 18-64","Children who did not receive needed mental health care"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/FL.json
// module id = 249
// module chunks = 143196823979170 184088790168614